import React from "react";
import { Flag, Award, MapPin } from "lucide-react";
import ClientGrid from "./ClientGrid";
import ViewAllOverlay from "./ViewAllOverlay";
import { AnimatedCountUp } from "./AnimatedNumber";

const PresenceSection = () => {
  return (
    <section
      id="clients"
      className="relative h-[65vh] bg-[#0D0D0D] overflow-hidden"
    >
      <div className="h-full overflow-hidden">
        <div className="container mx-auto px-6 lg:px-12 pt-12 pb-8 h-full">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            Our Clients Across India
          </h2>

          <div className="flex flex-wrap gap-3 mb-6">
            <div className="flex items-center gap-2 bg-[#2a1810] px-4 py-2 rounded border border-[#c9923f]/20">
              <Flag className="text-[#d4a574]" size={18} />
              <span className="text-white/90 text-sm">Made in India</span>
            </div>
            <div className="flex items-center gap-2 bg-[#2a1810] px-4 py-2 rounded border border-[#c9923f]/20">
              <Award className="text-[#d4a574]" size={18} />
              <span className="text-white/90 text-sm">
                <AnimatedCountUp value={750} suffix="+" /> Clients
              </span>
            </div>
            <div className="flex items-center gap-2 bg-[#2a1810] px-4 py-2 rounded border border-[#c9923f]/20">
              <MapPin className="text-[#d4a574]" size={18} />
              <span className="text-white/90 text-sm">Pan India</span>
            </div>
          </div>
          <ClientGrid />
        </div>
      </div>

      <ViewAllOverlay to="/clients" />
    </section>
  );
};

export default PresenceSection;
